<template>
  <div class="page-wrap">
    <div class="left-content">
      <transition
        appear
        appear-to-class="animate__animated animate__fadeInLeft animate__delay-1s"
      >
        <div class="upload-product-wrap" id="upLoadProductWrap">
          <div class="drawer-title" slot="title">
            <div class="txt">
              填写产品基本信息
            </div>
            <div class="sub-txt">
              Fill in product information
            </div>
          </div>
          <div class=" drawer-content" v-loading="submitLoading">
            <div class="form-wrap">
              <div class="select-country">
                <div class="product">
                  <el-popover
                    placement="left-start"
                    title="茶叶种类"
                    trigger="click"
                  >
                    <div class="avatar" slot="reference">
                      <div
                        class="avatar-view"
                        v-if="!uploadProductparams.templateId"
                      >
                        <img src="@/assets/image/tea.png" alt="" />
                        <div>
                          选择产品
                        </div>
                      </div>
                      <div class="selected-product" v-else>
                        <img :src="uploadProductparams.image" alt="" />
                      </div>
                    </div>
                    <div class="tea-template">
                      <div
                        class="tea-item"
                        @click="selectProduct(tea)"
                        v-for="(tea, teaIndex) in teaTemplate"
                        :key="teaIndex"
                      >
                        <div class="tea-main">
                          <img :src="tea.main" alt="" />
                        </div>
                        <div class="tea-images">
                          <img
                            v-for="(item, index) in tea.images"
                            :key="index"
                            :src="item"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div class="select">
                  <div class="item">
                    <el-popover placement="top" trigger="hover">
                      <div slot>
                        <div class="country-list" style="display: flex">
                          <img
                            @click="uploadProductparams.country = '马来西亚'"
                            src="@/assets/image/analysis/nalaixiya.png"
                            alt=""
                          />
                          <img
                            @click="uploadProductparams.country = '越南'"
                            src="@/assets/image/analysis/yuenan.png"
                            alt=""
                          />
                          <img
                            @click="uploadProductparams.country = '泰国'"
                            src="@/assets/image/analysis/taiguo.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div slot="reference">
                        <div style="text-align: center;margin-bottom: 6px">
                          <img
                            v-if="uploadProductparams.country === '马来西亚'"
                            src="@/assets/image/analysis/nalaixiya.png"
                            alt=""
                            height="60"
                          />
                          <img
                            v-else-if="uploadProductparams.country === '越南'"
                            src="@/assets/image/analysis/yuenan.png"
                            alt=""
                            height="60"
                          />
                          <img
                            v-else-if="uploadProductparams.country === '泰国'"
                            src="@/assets/image/analysis/taiguo.png"
                            alt=""
                            height="60"
                          />
                          <img
                            v-else
                            src="@/assets/image/country.png"
                            alt=""
                            height="60"
                          />
                        </div>
                        <div style="text-align: center">
                          {{
                            uploadProductparams.country
                              ? uploadProductparams.country
                              : "—"
                          }}
                        </div>
                        <div style="text-align:center">
                          <button>
                            选择国家
                          </button>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
              <div class="form-title form-data">
                <div class="label">
                  标题
                </div>
                <div class="input">
                  <el-popover
                    placement="left-start"
                    width="800"
                    trigger="click"
                  >
                    <textarea
                      v-model="uploadProductparams.title"
                      slot="reference"
                    ></textarea>
                    <div class="hint-wrap">
                      <div
                        class="hint-item"
                        v-for="(item, index) in hintData"
                        :key="index"
                      >
                        <div class="title">
                          {{ item.name }}
                        </div>
                        <div class="content">
                          <span v-for="itemm in item.items" :key="itemm">
                            {{ itemm }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div class="form-price-inventory form-data">
                <div class="form-price">
                  <div class="label">
                    关键词
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.gjc"
                      style="width:160px"
                    />
                  </div>
                </div>
                <div class="form-inventory">
                  <div class="label">
                    产品标签
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.tags"
                      style="width:160px"
                    />
                  </div>
                </div>
              </div>
              <div class="form-price-inventory form-data">
                <div class="form-price">
                  <div class="label">
                    价格(¥)
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.price"
                      type="number"
                      style="width:160px"
                    />
                  </div>
                </div>
                <div class="form-inventory">
                  <div class="label">
                    库存(kg)
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.stock"
                      type="number"
                      style="width:160px"
                    />
                  </div>
                </div>
              </div>
              <div class="form-price-inventory form-data">
                <div class="form-price">
                  <div class="label">
                    物流方式设置
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.wl"
                      style="width:160px"
                    />
                  </div>
                </div>
                <div class="form-inventory">
                  <div class="label">
                    库存设置
                  </div>
                  <div class="input">
                    <input
                      v-model="uploadProductparams.kc"
                      style="width:160px"
                    />
                  </div>
                </div>
              </div>
              <div class="form-description form-data">
                <div class="label">
                  描述
                </div>
                <div class="input">
                  <el-popover
                    placement="left-start"
                    width="800"
                    trigger="click"
                  >
                    <textarea
                      v-model="uploadProductparams.description"
                      slot="reference"
                    ></textarea>
                    <div class="hint-wrap">
                      <div
                        class="hint-item"
                        v-for="(item, index) in hintData"
                        :key="index"
                      >
                        <div class="title">
                          {{ item.name }}
                        </div>
                        <div class="content">
                          <span v-for="itemm in item.items" :key="itemm">
                            {{ itemm }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </div>
              <div>
                <div class="local-upload-wrap form-description form-data">
                  <div class="label">
                    附图上传（最多6张）
                  </div>
                  <el-upload
                    class="local-upload"
                    action=""
                    list-type="picture-card"
                    :auto-upload="false"
                    :show-file-list="true"
                    :on-change="handleLocalImageChange"
                    :on-remove="handleLocalImageRemove"
                    :on-exceed="handleLocalImageExceed"
                    :file-list="attachFileList"
                    :limit="6"
                    multiple
                    accept="image/*"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <div class="local-upload-tip">
                    支持 jpg/png/gif，大小≤5MB，最多上传6张
                  </div>
                </div>
              </div>
              <div class="form-submit form-data">
                <div class="other-country">
                  <div
                    class="other-item animate__backInDown animate__animated "
                    v-for="(item, index) in otherTea"
                    :key="index"
                    @click="selectProduct(item)"
                  >
                    <div class="select-country">
                      <div class="other-country-product">
                        <img :src="item.main" alt="" />
                      </div>
                      <div class="select">
                        <div class="item">
                          <img
                            v-if="
                              item.product &&
                                item.product.country === '马来西亚'
                            "
                            src="@/assets/image/analysis/nalaixiya.png"
                            alt=""
                            width="54"
                          />
                          <img
                            v-else-if="
                              item.product && item.product.country === '越南'
                            "
                            src="@/assets/image/analysis/yuenan.png"
                            alt=""
                            width="54"
                          />
                          <img
                            v-else-if="
                              item.product && item.product.country === '泰国'
                            "
                            src="@/assets/image/analysis/taiguo.png"
                            alt=""
                            width="54"
                          />
                          <img
                            v-else
                            src="@/assets/image/country.png"
                            alt=""
                            width="40"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="submit-btnn">
                  <button
                    @click="submitProduct()"
                    :class="{ left: isNext, isNext: isNext }"
                  >
                    <div class="text">
                      保 存
                    </div>
                    <div class="subText">
                      Edit Product
                    </div>
                  </button>
                  <button
                    @click="toNext()"
                    :class="{ right: isNext, isNext: isNext }"
                    v-if="isNext"
                  >
                    <div class="text">
                      下一步
                    </div>
                    <div class="subText">
                      NEXT
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="right-content">
      <div class="table-wrap" id="TableWrap">
        <transition
          appear
          appear-to-class="animate__animated animate__lightSpeedInLeft"
        >
          <el-table
            class="tea-table"
            :data="Malaysia"
            style="width: 100%;margin-bottom: 8px"
          >
            <el-table-column prop="date">
              <template slot="header">
                <div class="header-custom">
                  <img
                    :src="
                      require('./../../../assets/image/analysis/nalaixiya.png')
                    "
                    alt=""
                    width="91px"
                  />
                  <span class="txt">
                    马来西亚
                  </span>
                </div>
              </template>
              <template slot-scope="scope">
                <span class="category">
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="消费力">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.consumptionAbility }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="总销量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.totalSalesquantity }} kg
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="卖家数量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.sellers }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="评论数">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.comments }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </transition>
        <transition
          appear
          appear-to-class="animate__animated animate__lightSpeedInRight"
        >
          <el-table
            class="tea-table"
            :data="Thailand"
            style="width: 100%;margin-bottom: 8px"
          >
            <el-table-column prop="date">
              <template slot="header">
                <div class="header-custom">
                  <img
                    :src="
                      require('./../../../assets/image/analysis/taiguo.png')
                    "
                    alt=""
                    width="91px"
                  />
                  <span class="txt">
                    泰国
                  </span>
                </div>
              </template>
              <template slot-scope="scope">
                <span class="category">
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="消费力">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.consumptionAbility.currency }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="总销量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.totalSalesquantity }} kg
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="卖家数量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.sellers }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="评论数">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.comments }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </transition>
        <transition
          appear
          appear-to-class="animate__animated animate__lightSpeedInLeft"
        >
          <el-table
            class="tea-table"
            :data="Vietnam"
            style="width: 100%;margin-bottom: 8px"
          >
            <el-table-column prop="date">
              <template slot="header">
                <div class="header-custom">
                  <img
                    :src="
                      require('./../../../assets/image/analysis/yuenan.png')
                    "
                    alt=""
                    width="91px"
                  />
                  <span class="txt">
                    越南
                  </span>
                </div>
              </template>
              <template slot-scope="scope">
                <span class="category">
                  {{ scope.row.name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="消费力">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.consumptionAbility.currency }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="总销量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.totalSalesquantity }} kg
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="卖家数量">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.sellers }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="name" align="center" label="评论数">
              <template slot-scope="scope">
                <span class="strong-num">
                  {{ scope.row.comments }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </transition>
      </div>
    </div>
    <el-drawer
      append-to-body
      size="90%"
      title="我是标题"
      class="analysis-el-drawer"
      :with-header="false"
      show-close
      :visible.sync="echartDrawer"
      :direction="'ltr'"
    >
      <Analysis @close="moveNext"></Analysis>
    </el-drawer>
    <div class="btn-wrap" id="btnWrap" @click="showEchart">
      <div class="echart-img">
        <transition
          enter-active-class="animate__animated animate__fadeInLeft animate__delay-1s"
          leave-active-class="animate__animated animate__fadeOutRight"
          leave-to-class="animate__animated animate__fadeOutRight"
        >
          <img v-if="pieOrBar" src="@/assets/image/pie.png" alt="" />
        </transition>
        <transition
          enter-active-class="animate__animated animate__fadeInLeft animate__delay-1s"
          leave-active-class="animate__animated animate__fadeOutRight"
          leave-to-class="animate__animated animate__fadeOutRight"
        >
          <img v-if="!pieOrBar" src="@/assets/image/bar.png" alt="" />
        </transition>
      </div>
      <div>图表数据</div>
    </div>
    <stepDialog
      v-if="stepDialogStatus.show"
      :status="stepDialogStatus"
      @close="close"
    ></stepDialog>
  </div>
</template>

<script>
import Analysis from "./analysis";
import stepDialog from "../../../components/stepDialog";

export default {
  components: { Analysis, stepDialog },
  data() {
    return {
      localCacheKey: "comparison_product_cache",
      localCacheList: [],
      stepDialogStatus: {
        show: false,
        in: false,
        start: 5,
        end: 9,
        page: "comparison",
      },
      pieOrBar: true,
      Malaysia: [
        {
          name: "大红袍",
          consumptionAbility: "￥ 200 ~ 320",
          totalSalesquantity: "3214681",
          sellers: "3421",
          comments: "721634",
        },
        {
          name: "正山小种",
          consumptionAbility: "￥ 130 ~ 260",
          totalSalesquantity: "6271463",
          sellers: "4100",
          comments: "1633201",
        },
        {
          name: "茉莉花茶",
          consumptionAbility: "￥ 100 ~ 220",
          totalSalesquantity: "2477653",
          sellers: "2120",
          comments: "510032",
        },
      ],
      Thailand: [
        {
          name: "大红袍",
          consumptionAbility: {
            currency: "฿ 1120 ~ 1850.6",
            CNY: "￥ 230 ~ 380",
          },
          totalSalesquantity: "8634213",
          sellers: "5021",
          comments: "2013229",
        },
        {
          name: "正山小种",
          consumptionAbility: {
            currency: "฿ 487 ~ 1120",
            CNY: "￥ 100 ~ 230",
          },
          totalSalesquantity: "3031204",
          sellers: "2764",
          comments: "876345",
        },
        {
          name: "茉莉花茶",
          consumptionAbility: {
            currency: "฿ 438 ~ 974",
            CNY: "￥ 90 ~ 200",
          },
          totalSalesquantity: "2877620",
          sellers: "2879",
          comments: "760042",
        },
      ],
      Vietnam: [
        {
          name: "大红袍",
          consumptionAbility: {
            currency: "￥ 180 ~ 280",
            CNY: "￥ 180 ~ 280",
          },
          totalSalesquantity: "4187620",
          sellers: "3760",
          comments: "612643",
        },
        {
          name: "正山小种",
          consumptionAbility: {
            currency: "￥ 80 ~ 240",
            CNY: "￥ 80 ~ 240",
          },
          totalSalesquantity: "2967437",
          sellers: "2342",
          comments: "667890",
        },
        {
          name: "茉莉花茶",
          consumptionAbility: {
            currency: "￥ 120 ~ 260",
            CNY: "￥ 120 ~ 260",
          },
          totalSalesquantity: "7786349",
          sellers: "4437",
          comments: "1982732",
        },
      ],
      drawer: false,
      echartDrawer: false,
      imageUrl: "",
      teaTemplate: [],
      hintDrawer: false,
      submitLoading: false,
      attachFileList: [],
      uploadProductparams: {
        experimentId: "",
        templateId: "",
        country: "",
        title: "",
        price: "",
        stock: "",
        description: "",
        image: "",
        productId: "",
        gjc: "",
        tags: "",
        wl: "",
        kc: "",
        attachImages: [],
      },
      hintData: [
        {
          name: "品名",
          items: [
            "大红袍金骏眉",
            "武夷岩茶",
            "铁观音",
            "乌龙茶",
            "毛峰",
            "毛尖",
            "瓜片",
            "龙井",
            "菊花",
            "普洱",
            "正山小种",
            "红茶",
            "茉莉花茶",
          ],
        },
        {
          name: "品牌",
          items: ["致悟®", "日春", "优衣库", "五粮液", "sdidas", "NIKE"],
        },
        {
          name: "口味",
          items: ["回甘", "香浓", "苦涩", "香甜", "寡淡", "清爽", "松烟果味"],
        },
        {
          name: "加工工艺",
          items: ["半发酵", "窖制茶胚", "全发酵", "水煮", "烟熏"],
        },
        {
          name: "健康",
          items: ["行气开郁", "消食祛腻", "养胃护脾"],
        },
        {
          name: "使用场景",
          items: ["商用", "休闲", "家庭", "旅行"],
        },
        {
          name: "产品属性",
          items: ["绿茶", "红茶", "乌龙茶", "黑茶", "白茶"],
        },
        {
          name: "包装",
          items: ["散装", "袋装", "铁盒", "伴手礼", "商务套装"],
        },
        {
          name: "主产地",
          items: ["黄山", "天山", "武夷山", "西湖", "安溪", "福州", "福鼎"],
        },
        {
          name: "储存方式",
          items: ["密封", "避光", "防潮", "防异味", "高温", "高压"],
        },
      ],
      DriverInstance: null,
    };
  },
  computed: {
    otherTea() {
      let $tea = this.teaTemplate.filter((item) => {
        return (
          item.product &&
          item.product.template_id !== this.uploadProductparams.templateId
        );
      });
      return $tea;
    },
    isNext() {
      let i = 0;
      this.teaTemplate.forEach((item) => {
        item.product ? i++ : "";
      });
      return i > 0;
    },
  },
  created() {
    if (!localStorage.getItem("comparison")) {
      setTimeout(() => {
        this.stepDialogStatus.show = true;
        this.stepDialogStatus.in = true;
      }, 2000);
    }

    setInterval(() => {
      this.pieOrBar = !this.pieOrBar;
    }, 10000);
    this.getTemplate();

    // 读取本地缓存（数组），后续选择产品时用于与服务端数据合并覆盖
    try {
      const cacheStr = localStorage.getItem(this.localCacheKey);
      if (cacheStr) {
        const parsed = JSON.parse(cacheStr);
        this.localCacheList = Array.isArray(parsed)
          ? parsed
          : parsed
          ? [parsed]
          : [];
      }
    } catch (e) {
      console.log(e);
    }
  },
  mounted() {
    // this.stepStart()
  },
  beforeRouteLeave(to, from, next) {
    if (this.DriverInstance) {
      this.DriverInstance.reset();
    }
    next();
  },
  watch: {
    echartDrawer: function(newv) {
      if (
        !newv &&
        localStorage.getItem("Comparison1") &&
        localStorage.getItem("Comparison2") &&
        !localStorage.getItem("Comparison3")
      ) {
        setTimeout(() => {
          document.querySelector("html").scrollTop = 0;
          this.DriverInstance = this.Driver("Comparison3");
          this.DriverInstance.start();
        }, 1000);
      }
      if (
        newv &&
        !localStorage.getItem("Comparison2") &&
        !localStorage.getItem("Comparison3")
      ) {
        this.DriverInstance.reset();
        this.DriverInstance = null;
        setTimeout(() => {
          document.querySelector("html").scrollTop = 0;
          this.DriverInstance = this.Driver("Comparison2");
          this.DriverInstance.start();
        }, 1000);
      }
    },
    "stepDialogStatus.show": function(newv) {
      if (newv) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "initial";
      }
    },
    // 表单改动即写入本地缓存
    uploadProductparams: {
      handler() {
        this.saveLocalCache();
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.stepDialogStatus.in = false;
      setTimeout(() => {
        this.stepDialogStatus.show = false;
      }, 1000);
    },
    stepStart() {
      if (!localStorage.getItem("Comparison1")) {
        this.DriverInstance = this.Driver("Comparison1");
        setTimeout(() => {
          this.DriverInstance.start();
        }, 2000);
      }
    },
    moveNext() {
      this.echartDrawer = false;
    },
    showEchart() {
      this.echartDrawer = true;
    },
    getTemplate() {
      return new Promise((resolve) => {
        this.$axios
          .post("/student/data/present/upload/template", {
            expId: this.$route.query.id,
          })
          .then((res) => {
            if (res.succeed) {
              this.teaTemplate = res.items;
              if (
                this.teaTemplate.filter((item) => {
                  return item.product;
                }).length === 3 &&
                !this.uploadProductparams.templateId
              ) {
                for (let i in this.uploadProductparams) {
                  this.uploadProductparams[i] = this.teaTemplate[0].product[i];
                }
                this.uploadProductparams.templateId = this.teaTemplate[0].template_id;
                this.uploadProductparams.productId = this.teaTemplate[0].product.product_id;
                this.uploadProductparams.image = this.teaTemplate[0].main;
                // 默认选中时也用本地缓存进行覆盖
                const local = this.getLocalEntry(
                  this.uploadProductparams.productId,
                  this.uploadProductparams.templateId
                );
                if (local) {
                  for (let k in local) {
                    if (k in this.uploadProductparams) {
                      this.uploadProductparams[k] = local[k];
                    }
                  }
                }
                // 回填附图缩略图
                if (Array.isArray(this.uploadProductparams.attachImages)) {
                  this.attachFileList = this.uploadProductparams.attachImages.map(
                    (url, idx) => ({
                      name: `附图${idx + 1}`,
                      url,
                    })
                  );
                }
              }
              resolve();
            }
          });
      });
    },
    createProduct() {
      this.createProductParams.experiment.id = this.$route.query.id;
      this.$axios
        .post("/student/data/present/upload/product", this.createProductParams)
        .then(() => {});
    },
    selectProduct(item) {
      // 先读取服务端的产品参数（present/upload/template返回的数据）
      if (item.product) {
        for (let i in this.uploadProductparams) {
          if (i === "attachImages") continue;
          this.uploadProductparams[i] = item.product[i];
        }
        this.uploadProductparams.templateId = item.template_id;
        this.uploadProductparams.image = item.main;
        this.uploadProductparams.productId = item.product.product_id;
      } else {
        for (let i in this.uploadProductparams) {
          if (i === "attachImages") continue;
          this.uploadProductparams[i] = "";
        }
        this.uploadProductparams.templateId = item.template_id;
        this.uploadProductparams.image = item.main;
        this.uploadProductparams.productId = "";
      }

      // 再用本地缓存数组进行覆盖（优先本地修改）
      const local = this.getLocalEntry(
        this.uploadProductparams.productId,
        this.uploadProductparams.templateId
      );
      if (local) {
        for (let k in local) {
          if (k in this.uploadProductparams) {
            this.uploadProductparams[k] = local[k];
          }
        }
      }
      // 回填附图缩略图
      if (Array.isArray(this.uploadProductparams.attachImages)) {
        this.attachFileList = this.uploadProductparams.attachImages.map(
          (url, idx) => ({
            name: `附图${idx + 1}`,
            url,
          })
        );
      } else {
        this.attachFileList = [];
      }
    },
    // 根据 productId 或 templateId 查找本地缓存项
    getLocalEntry(productId, templateId) {
      if (!Array.isArray(this.localCacheList)) return null;
      if (productId) {
        const byPid = this.localCacheList.find(
          (it) => it && it.productId === productId
        );
        if (byPid) return byPid;
      }
      return (
        this.localCacheList.find(
          (it) => it && !it.productId && it.templateId === templateId
        ) || null
      );
    },
    // 处理本地附图上传，转换为 base64 并缓存（最多6张）
    handleLocalImageChange(file, fileList) {
      const raw = file.raw || file;
      if (!raw) return;
      if (raw.size && raw.size > 5 * 1024 * 1024) {
        this.$message.error("图片大小不能超过 5MB");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64 = e.target.result;
        // 设置预览 url
        file.url = base64;
        this.attachFileList = fileList;
        this.uploadProductparams.attachImages = (fileList || [])
          .map((f) => f.url)
          .filter(Boolean)
          .slice(0, 6);
        this.saveLocalCache();
      };
      reader.readAsDataURL(raw);
    },
    handleLocalImageRemove(file, fileList) {
      this.attachFileList = fileList;
      this.uploadProductparams.attachImages = (fileList || [])
        .map((f) => f.url)
        .filter(Boolean)
        .slice(0, 6);
      this.saveLocalCache();
    },
    handleLocalImageExceed() {
      this.$message.warning("最多上传 6 张附图");
    },
    // 将当前表单保存到本地缓存
    saveLocalCache() {
      try {
        const expId = this.$route.query.id;
        const entry = {
          ...this.uploadProductparams,
          experimentId: expId,
          savedAt: new Date().toISOString(),
        };
        const productId = entry.productId || "";
        const templateId = entry.templateId || "";
        let list = Array.isArray(this.localCacheList)
          ? [...this.localCacheList]
          : [];
        let idx = -1;
        if (productId)
          idx = list.findIndex((it) => it && it.productId === productId);
        if (idx < 0 && templateId)
          idx = list.findIndex(
            (it) => it && !it.productId && it.templateId === templateId
          );
        if (idx >= 0) list[idx] = entry;
        else list.push(entry);
        this.localCacheList = list;
        localStorage.setItem(this.localCacheKey, JSON.stringify(list));
      } catch (e) {
        console.log(e);
      }
    },
    // 基于实验ID的产品列表持久化（数组，可包含多个商品详情）
    saveLocalList() {
      try {
        const expId = this.$route.query.id;
        const listKey = `comparison_product_list_${expId}`;
        const raw = localStorage.getItem(listKey);
        const list = raw ? JSON.parse(raw) : [];
        const entry = JSON.parse(
          JSON.stringify({
            ...this.uploadProductparams,
            experimentId: expId,
            savedAt: new Date().toISOString(),
          })
        );
        if (entry.productId) {
          const idx = list.findIndex(
            (it) => it && it.productId === entry.productId
          );
          if (idx >= 0) list[idx] = entry;
          else list.push(entry);
        } else {
          list.push(entry);
        }
        localStorage.setItem(listKey, JSON.stringify(list));
      } catch (e) {
        console.log(e);
      }
    },
    submitProduct() {
      if (!this.uploadProductparams.templateId) {
        this.$message.error("请选择茶产品");
        return false;
      }
      if (!this.uploadProductparams.country) {
        this.$message.error("请选择国家");
        return false;
      }
      if (!this.uploadProductparams.title) {
        this.$message.error("请填写产品的标题");
        return false;
      }
      if (!this.uploadProductparams.price) {
        this.$message.error("请填写产品价格");
        return false;
      }
      if (!this.uploadProductparams.stock) {
        this.$message.error("请填写产品库存");
        return false;
      }
      this.uploadProductparams.experimentId = this.$route.query.id;
      // 提交前也写入本地缓存，保证预览数据完整
      this.saveLocalCache();
      // 将当前产品写入基于实验ID的本地列表（数组）
      this.saveLocalList();
      this.submitLoading = true;
      this.$axios
        .post(
          this.uploadProductparams.productId
            ? "/student/data/present/editor/product"
            : "/student/data/present/upload/product",
          this.uploadProductparams
        )
        .then((res) => {
          setTimeout(() => {
            this.submitLoading = false;
          }, 500);

          if (res.succeed) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTemplate().then(() => {
              this.$nextTick(() => {
                let $teaTemplate = this.teaTemplate.filter((item) => {
                  return item.product;
                });
                if ($teaTemplate.length < 3) {
                  for (let i in this.uploadProductparams) {
                    this.uploadProductparams[i] = "";
                  }
                }
              });
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
    },
    toNext() {
      this.$router.push({
        path: "/data/putaway",
        query: this.$route.query,
      });
    },
  },
};
</script>

<style>
.el-drawer__wrapper.analysis-el-drawer.driver-fix-stacking {
  position: absolute !important;
  z-index: 999;
}
div#driver-popover-item.prevvvv .driver-popover-footer button.driver-prev-btn {
  display: none !important;
}
</style>
<style scoped lang="scss">
::v-deep .v-modal {
}

.page-wrap {
  display: flex;

  .left-content {
    width: 400px;
    min-width: 400px;
    height: 722px;
    margin-right: 40px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 12px;
    overflow: hidden;

    .upload-product-wrap {
      background: white;
      padding: 30px;
      width: 400px;
      height: 700px;
      border-radius: 12px;
      overflow-y: auto;

      div.drawer-content {
        display: flex;
        flex-direction: column;
        height: 100%;

        .form-wrap {
          flex: 1;

          .select-country {
            box-shadow: 0px 0px 6px rgba(158, 158, 158, 0.47);
            height: 160px;
            border-radius: 12px;
            border: 2px solid #f1f1f1;
            display: flex;
            margin-bottom: 20px;

            .product {
              width: 230px;
              border-right: 1px solid #f1f1f1;
              padding: 8px;
            }

            .select {
              display: flex;
              justify-content: center;
              flex: 1;

              .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-size: 22px;
                color: #999999;

                button {
                  margin-top: 8px;
                  width: 82px;
                  height: 33px;
                  background: linear-gradient(312deg, #005be7 0%, #70a0eb 100%);
                  box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                  border-radius: 60px;
                  font-size: 14px;
                  color: white;
                  font-family: "Microsoft YaHei", sans-serif;
                }
              }
            }
          }

          .form-data {
            .label {
              height: 18px;
              font-size: 14px;
              font-family: Microsoft YaHei UI, sans-serif;
              font-weight: 400;
              line-height: 18px;
              color: #999999;
              margin-bottom: 8px;
            }

            .input {
              textarea {
                resize: none;
                padding: 8px 18px;
                width: 100%;
                height: 60px;
                background: #ffffff;
                border: 2px solid #f1f1f1;
                border-radius: 12px;
                font-size: 16px;
                font-family: Microsoft YaHei UI, sans-serif;
                font-weight: 400;
              }

              input {
                padding: 0 18px;
                font-size: 16px;
                height: 48px;
                background: #ffffff;
                border: 2px solid #f1f1f1;
                border-radius: 12px;
              }
            }

            button {
              margin-top: 10px;
              border-radius: 64px;
              width: 100%;
              height: 58px;
              background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
              box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);

              &.left {
                border-radius: 64px 0 0 64px;
                transition: all 0.3s linear;
              }

              &.right {
                background: linear-gradient(90deg, #005be7 0%, #70a0eb 100%);
                border-radius: 0 64px 64px 0;
                transition: all 0.3s linear;
              }

              &.isNext {
                width: 50%;
              }

              .text {
                font-size: 22px;
                font-family: Microsoft YaHei UI;
                font-weight: 400;
                line-height: 26px;
                color: #ffffff;
              }

              .subText {
                font-size: 10px;
                font-weight: 400;
                line-height: 14px;
                color: #ffffff;
              }
            }
          }

          .form-title {
            margin-bottom: 18px;
          }

          .form-price-inventory {
            display: flex;
            justify-content: space-between;
            margin-bottom: 18px;
          }

          .form-submit {
          }
        }

        .other-country {
          height: 64px;
          display: flex;
          margin-top: 10px;

          .other-item {
            cursor: pointer;
            width: 50%;
            height: 64px;
            background: #ffffff;
            border: 2px solid #f1f1f1;
            border-radius: 12px;
            overflow: hidden;

            &:first-child {
              margin-right: 8px;
            }

            &:hover {
              transition: box-shadow 0.3s linear;
              box-shadow: 0 0 10px #cacaca;
            }

            .select-country {
              height: 100%;
              border-radius: 12px;
              display: flex;
              margin-bottom: 20px;
              cursor: pointer;

              .other-country-product {
                width: 100px;
                height: 100%;
                text-align: center;
                border-right: 1px solid #f1f1f1;

                img {
                  max-width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .select {
                display: flex;
                justify-content: center;
                flex: 1;

                .item {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  font-size: 10px;
                  color: #999999;

                  button {
                    margin-top: 10px;
                    width: 39px;
                    height: 18px;
                    background: linear-gradient(
                      312deg,
                      #005be7 0%,
                      #70a0eb 100%
                    );
                    box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
                    border-radius: 60px;
                    font-size: 10px;
                    color: white;
                    font-family: "Microsoft YaHei", sans-serif;
                  }
                }
              }
            }
          }
        }
      }

      div.drawer-title {
        margin-bottom: 10px;

        .txt {
          font-size: 26px;
          font-weight: bold;
          line-height: 33px;
          color: #454b60;
        }

        .sub-txt {
          font-size: 12px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          line-height: 15px;
          color: #999999;
        }
      }
    }
  }

  .right-content {
    flex-grow: 1;
    flex-shrink: 1;
    height: 722px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 12px;
    overflow: hidden;

    div.table-wrap {
      height: 772px;
      background: #ffffff;
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      border-radius: 12px;
      padding: 30px;

      .header-custom {
        img {
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .txt {
          margin-left: 100px;
        }
      }

      .category {
        padding-left: 20px;
        font-size: 22px;
        font-weight: 400;
        color: #999999;
      }

      .strong-num {
        display: inline-block;
        font-size: 26px;
        font-family: Bahnschrift, serif;
        font-weight: bold;
        color: #666666;
        position: relative;
        top: 3px;
      }
    }
  }
}

.tea-template {
  padding: 20px;

  .tea-item {
    cursor: pointer;
    border-radius: 12px;
    width: 320px;
    height: 220px;
    margin-bottom: 20px;
    display: flex;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.26);
    overflow: hidden;
    transition: box-shadow 0.3s linear;

    &:hover {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
      transition: box-shadow 0.3s linear;
    }

    .tea-main {
      width: 260px;
      height: 100%;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .tea-images {
      display: flex;
      flex-direction: column;

      img {
        margin-bottom: 2px;
        width: 60px;
        height: 45px;
        object-fit: cover;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}

.avatar {
  width: 100%;
  height: 100%;

  .avatar-view {
    width: 100%;
    height: 100%;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    color: #6acb90;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > img {
      width: 120px;
      margin-bottom: 20px;
      transition: width 0.5s ease-in-out;
      cursor: pointer;
    }

    &:hover {
      img {
        width: 140px;
        transition: width 0.5s ease-in-out;
      }
    }
  }

  .selected-product {
    width: 100%;
    height: 100%;

    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      cursor: pointer;
    }
  }
}

.country-list {
  display: flex;

  > img {
    width: 80px;
  }
}

.btn-wrap {
  cursor: pointer;
  border-radius: 6px;
  overflow: hidden;
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
  text-align: center;
  font-size: 22px;
  font-family: Microsoft YaHei UI;
  font-weight: 400;
  line-height: 26px;
  color: #ffffff;
  padding: 10px 0;

  .echart-img {
    width: 100px;
    height: 100px;
    text-align: center;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      object-fit: contain;
    }
  }

  button {
    width: 120px;
    height: 64px;
    box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);

    .text {
      font-size: 22px;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      line-height: 26px;
      color: #ffffff;
    }

    .subText {
      font-size: 10px;
      font-weight: 400;
      line-height: 14px;
      color: #ffffff;
    }
  }
}

.hint-wrap {
  background: url("./../../../assets/image/bg-2.png") center center no-repeat;

  .hint-item {
    .title {
      padding: 6px;
      font-size: 18px;
      font-weight: bold;
    }

    .content {
      padding: 6px 20px;

      span {
        padding: 0 10px;
        border-right: 2px solid #748aa1;

        &:last-child {
          border-right: none;
        }
      }
    }
  }
}
</style>
